function formatDate(date: Date) {
    if(date === null || date === undefined) return "Unknown Date";
    return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
}

function formatDateWithoutYear(date: Date) {
    if(date === null || date === undefined) return "Unknown Date";
    return date.getDate() + "." + (date.getMonth() + 1);

}

function formatTime(date: Date) {
    if(date === null || date === undefined) return "Unknown Time";
    return date.getHours().toString().padStart(2, '0') + ":" + date.getMinutes().toString().padStart(2, '0');
}

export {formatDate, formatDateWithoutYear, formatTime}